module.exports = __webpack_public_path__ + "e094848999cedda180dc16da38c70846.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-29.png
// module id = 2396
// module chunks = 0